import Quill from 'quill';

const InlineEmbed = Quill.import('blots/inline');

class HighlightBlot extends InlineEmbed {
  static create(attrs) {
    const { value } = attrs;
    const node = super.create(value);
    node.innerText = value;
    return node;
  }

  static formats(node) {
    return {
      value: node.innerText,
    };
  }
}

HighlightBlot.blotName = 'HighlightEmbed';
HighlightBlot.className = 'ql-high-light-embed';
HighlightBlot.tagName = 'span';

export default HighlightBlot;
